import { Circle, CircleSize, Inline, TouchableBox, useTheme } from "arkh";

import React from "react";

type ColorSelectProps = {
  selected: string | undefined;
  setSelected: (selected: string) => void;
};

export function ColorSelect({ selected, setSelected }: ColorSelectProps) {
  const theme = useTheme();
  return (
    <Inline space="small">
      {theme.colorScheme.map((color) => (
        <TouchableBox
          key={color}
          onPress={() => {
            setSelected(color);
          }}
        >
          <ColorSelectItem
            color={color}
            selected={selected === color}
            size="medium"
          />
        </TouchableBox>
      ))}
    </Inline>
  );
}

export function ColorSelectItem({
  color,
  selected,
  size = "smallMedium",
}: {
  color?: string;
  selected: boolean;
  size?: CircleSize;
}) {
  const theme = useTheme();
  return (
    <Circle
      style={{
        backgroundColor: color,
        borderColor: theme.darkerText,
        borderWidth: selected ? 2 : 0,
      }}
      size={size}
    />
  );
}
